import * as types from './actionTypes'

export const getSynth = (synthesis) => ({
  type: types.GET_SYNTHESIS,
  synthesis
})



// WEBPACK FOOTER //
// ./src/actions/synthesisActions.js